import {
    DependenciesPayload,
    IWebSDKLocale,
} from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAccessToken,
    normalizeLangToLocaleForServiceCall,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

export async function getOffersCommerceInfo(
    {
        offerIds,
        countryCode,
        province,
        locale,
    }: {
        offerIds: string[];
        countryCode: string;
        province?: string;
        locale: IWebSDKLocale;
    },
    { appEventSdk, microservicesSdk }: DependenciesPayload,
) {
    try {
        const request = {
            offerIds: offerIds,
            accessToken: getAccessToken(),
            ...(province && countryCode.toLowerCase() === 'ca'
                ? { province: province }
                : {}),
            locales: locale.supported.map((locale) =>
                normalizeLangToLocaleForServiceCall(
                    locale,
                    countryCode,
                    province,
                ),
            ),
        };
        return await microservicesSdk.domains.offers.getOffersCommerceInfo(
            request,
        );
    } catch (error: any) {
        if (error.errorType === 'BUSINESS') {
            trackBusinessError(appEventSdk, error);
        } else {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
        }
        throw new Error('SYSTEM');
    }
}
